




















import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { onMounted, Ref, ref } from "@vue/composition-api";
import Sessions from "./Sessions.vue";
import { ScanSession } from "../../data/model";

type SessionModalProps = {
  modalData: {
    selected_session_id?: string;
    from_sessions?: ScanSession[];
    has_session_params: boolean;
  };
};
export default Vue.extend({
  components: {
    Modal,
    Sessions,
  },

  props: ["modalData"],
  setup(props, { emit }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "100rem",
      height: "70rem",
      withTopRightCloseBtn: true,
    };
    const is_modal_open = ref(false);

    const selected_session_id = ref("");
    const sessions: Ref<ScanSession[]> = ref([]);

    const set_selected_session = (session: ScanSession) => {
      emit("submit", session);
    };

    onMounted(() => {
      const { modalData } = props as SessionModalProps;
      if (modalData.from_sessions) {
        sessions.value = modalData.from_sessions;
      }
      if (modalData.selected_session_id) {
        selected_session_id.value = modalData.selected_session_id;
      }
      setTimeout(() => {
        is_modal_open.value = true;
      }, 300);
    });

    return {
      config,
      is_modal_open,
      selected_session_id,
      sessions,
      set_selected_session,
    };
  },
});
